(function() {
  var ENDPOINT = window.RSP_TRACKING_ENDPOINT || 'https://respiria-tracking-api.jameslindy.workers.dev/v1/events';
  var VISITOR_KEY = 'rsp_visitor_id';
  var SESSION_KEY = 'rsp_session_state';
  var FIRST_TOUCH_KEY = 'rsp_first_touch';
  var QUEUE_KEY = 'rsp_event_queue';
  var SESSION_TIMEOUT_MS = 60 * 60 * 1000;
  var VISITOR_COOKIE_DAYS = 400;
  var EVENT_QUEUE = [];
  var FLUSH_TIMER = null;
  var FLUSH_IN_PROGRESS = false;
  var FLUSH_AGAIN = false;
  var RETRY_DELAY_MS = 1500;
  var DEFAULT_FLUSH_DELAY_MS = 200;
  var FETCH_TIMEOUT_MS = 4000;
  var MAX_BATCH = 20;
  var MAX_QUEUE = 500;
  var INTERNAL_HOSTS = (window.RSP_INTERNAL_HOSTS || [
    'respiria.com',
    'try.respiria.com',
    '3rp171-km.myshopify.com'
  ]);
  var ATTR_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id',
    'fbclid', 'gclid', 'ttclid', 'msclkid',
    'campaign_id', 'campaignid', 'campaign_name',
    'adset_id', 'ad_set_id', 'adset', 'adset_name',
    'ad_id', 'adid', 'ad_name',
    'creative_id', 'placement', 'site_source_name'
  ];

  function nowIso() { return new Date().toISOString(); }
  function nowMs() { return Date.now(); }
  function clean(value) { return String(value || '').trim(); }

  function readJson(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || '');
    } catch (error) {
      return null;
    }
  }

  function writeJson(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  function readQueue() {
    var items = readJson(QUEUE_KEY);
    if (!Array.isArray(items)) return [];
    return dedupeEvents(items.filter(function(item) {
      return item && typeof item === 'object' && clean(item.event_id) && clean(item.session_id) && clean(item.visitor_id);
    })).slice(-MAX_QUEUE);
  }

  function dedupeEvents(items) {
    var seen = {};
    return (items || []).filter(function(item) {
      var id = clean(item && item.event_id);
      if (!id || seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }

  function persistQueue() {
    var originalItems = dedupeEvents(EVENT_QUEUE).slice(-MAX_QUEUE);
    var items = originalItems;
    while (items.length) {
      try {
        localStorage.setItem(QUEUE_KEY, JSON.stringify(items));
        EVENT_QUEUE = items;
        return;
      } catch (error) {
        items = items.slice(Math.ceil(items.length / 4));
      }
    }
    try {
      localStorage.removeItem(QUEUE_KEY);
    } catch (error) {}
    EVENT_QUEUE = originalItems;
  }

  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=' + maxAge + '; Path=/; SameSite=Lax; Secure';
  }

  function getCookie(name) {
    var prefix = name + '=';
    return document.cookie.split(';').map(function(part) { return part.trim(); }).filter(function(part) {
      return part.indexOf(prefix) === 0;
    }).map(function(part) {
      return decodeURIComponent(part.slice(prefix.length));
    })[0] || '';
  }

  function makeId(prefix) {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return prefix + window.crypto.randomUUID();
    }
    return prefix + Math.random().toString(16).slice(2) + '-' + Date.now().toString(16);
  }

  // The cookie wins over localStorage: the tracking API re-sets it as an HTTP
  // cookie on every event batch, which survives Safari ITP's 7-day cap on
  // script-written storage.
  function getVisitorId() {
    var stored = getCookie(VISITOR_KEY) || localStorage.getItem(VISITOR_KEY);
    if (!stored || stored.indexOf('rspv_') !== 0) stored = makeId('rspv_');
    try { localStorage.setItem(VISITOR_KEY, stored); } catch (error) {}
    setCookie(VISITOR_KEY, stored, VISITOR_COOKIE_DAYS);
    return stored;
  }

  function urlParams() {
    return new URLSearchParams(window.location.search || '');
  }

  function isSelfReferrer(referrer) {
    if (!referrer) return false;
    try {
      var host = new URL(referrer).hostname.replace(/^www\./, '');
      if (host === window.location.hostname.replace(/^www\./, '')) return true;
      return INTERNAL_HOSTS.indexOf(host) >= 0;
    } catch (error) {
      return false;
    }
  }

  function normalizeSource(value) {
    var source = clean(value).toLowerCase();
    if (!source) return '';
    if (['fb', 'facebook', 'facebook.com', 'm.facebook.com', 'l.facebook.com', 'lm.facebook.com'].indexOf(source) >= 0) return 'facebook';
    if (['ig', 'instagram', 'instagram.com', 'l.instagram.com'].indexOf(source) >= 0) return 'instagram';
    if (['msg', 'messenger', 'messenger.com', 'm.me'].indexOf(source) >= 0) return 'messenger';
    if (['an', 'audience_network', 'audience-network', 'audiencenetwork'].indexOf(source) >= 0) return 'audience_network';
    if (source === 'google.com') return 'google';
    return source;
  }

  function sourceFromReferrer(referrer) {
    if (!referrer || isSelfReferrer(referrer)) return '';
    try {
      return normalizeSource(new URL(referrer).hostname.replace(/^www\./, ''));
    } catch (error) {
      return '';
    }
  }

  function currentRawAttribution() {
    var params = urlParams();
    var raw = {};
    ATTR_KEYS.forEach(function(key) {
      var value = params.get(key);
      if (value) raw[key] = value;
    });
    // Meta pixel cookies feed the server-side CAPI events.
    var fbp = getCookie('_fbp');
    var fbc = getCookie('_fbc');
    if (fbp) raw._fbp = fbp;
    if (fbc) raw._fbc = fbc;
    return raw;
  }

  function normalizeAttribution(raw) {
    raw = raw || {};
    var referrer = document.referrer || '';
    var source = normalizeSource(raw.utm_source || raw.site_source_name || raw.source || sourceFromReferrer(referrer));
    if (!source && (raw.fbclid || raw.campaign_id || raw.campaignid || raw.adset_id || raw.ad_id)) source = 'facebook';
    return {
      source: source || 'direct',
      medium: clean(raw.utm_medium || raw.medium),
      campaign_id: clean(raw.campaign_id || raw.campaignid || raw.utm_id),
      campaign_name: clean(raw.campaign_name || raw.utm_campaign),
      adset_id: clean(raw.adset_id || raw.ad_set_id),
      adset_name: clean(raw.adset_name || raw.adset || raw.utm_term),
      ad_id: clean(raw.ad_id || raw.adid),
      ad_name: clean(raw.ad_name || raw.utm_content),
      landing_page: window.location.href,
      referrer: isSelfReferrer(referrer) ? '' : referrer,
      fbclid: clean(raw.fbclid),
      gclid: clean(raw.gclid),
      ttclid: clean(raw.ttclid),
      msclkid: clean(raw.msclkid),
      raw: raw
    };
  }

  function hasPaidClick(raw) {
    return Boolean(raw.fbclid || raw.gclid || raw.ttclid || raw.msclkid || raw.campaign_id || raw.campaignid || raw.adset_id || raw.ad_id || raw.utm_id || raw.utm_campaign);
  }

  function materialAttributionChanged(previous, next) {
    if (!previous || !next) return false;
    var keys = ['campaign_id', 'adset_id', 'ad_id', 'fbclid', 'gclid', 'ttclid', 'msclkid'];
    var hadPaid = keys.some(function(key) { return clean(previous[key]); });
    var hasPaid = keys.some(function(key) { return clean(next[key]); });
    if (hasPaid && !hadPaid) return true;
    return keys.some(function(key) {
      return clean(next[key]) && clean(previous[key]) !== clean(next[key]);
    });
  }

  function getFirstTouch(current) {
    var first = readJson(FIRST_TOUCH_KEY);
    if (!first) {
      first = current;
      writeJson(FIRST_TOUCH_KEY, first);
    }
    return first;
  }

  function getSessionState() {
    var visitorId = getVisitorId();
    var raw = currentRawAttribution();
    var currentTouch = normalizeAttribution(raw);
    var firstTouch = getFirstTouch(currentTouch);
    var existing = readJson(SESSION_KEY);
    var expired = !existing || !existing.last_seen_at_ms || (nowMs() - Number(existing.last_seen_at_ms)) > SESSION_TIMEOUT_MS;
    var newPaidClick = existing && hasPaidClick(raw) && materialAttributionChanged(existing.attribution && existing.attribution.session, currentTouch);

    if (!existing || existing.session_id.indexOf('rsps_') !== 0 || expired || newPaidClick) {
      existing = {
        session_id: makeId('rsps_'),
        visitor_id: visitorId,
        started_at: nowIso(),
        started_at_ms: nowMs(),
        sequence_number: 0,
        attribution: {
          first: firstTouch,
          session: currentTouch
        }
      };
    }

    existing.visitor_id = visitorId;
    existing.last_seen_at = nowIso();
    existing.last_seen_at_ms = nowMs();
    existing.landing_page = existing.attribution && existing.attribution.session ? existing.attribution.session.landing_page : window.location.href;
    existing.referrer = existing.attribution && existing.attribution.session ? existing.attribution.session.referrer : '';
    writeJson(SESSION_KEY, existing);
    setCookie('rsp_session_id', existing.session_id, 1);
    return existing;
  }

  var SESSION = getSessionState();
  EVENT_QUEUE = readQueue();

  function attribution() {
    SESSION = getSessionState();
    return SESSION.attribution || {};
  }

  function nextSequenceNumber() {
    SESSION.sequence_number = Number(SESSION.sequence_number || 0) + 1;
    writeJson(SESSION_KEY, SESSION);
    return SESSION.sequence_number;
  }

  function sanitizeProperties(properties) {
    var copy = {};
    Object.keys(properties || {}).forEach(function(key) {
      if (['name', 'first_name', 'last_name', 'email', 'phone', 'address'].indexOf(String(key).toLowerCase()) >= 0) return;
      copy[key] = properties[key];
    });
    return copy;
  }

  function track(eventName, properties) {
    SESSION = getSessionState();
    var sequenceNumber = nextSequenceNumber();
    var safeProperties = sanitizeProperties(properties || {});
    safeProperties.sequence_number = sequenceNumber;
    var event = {
      event_id: makeId('rspe_'),
      session_id: SESSION.session_id,
      visitor_id: SESSION.visitor_id,
      event_name: eventName,
      occurred_at: nowIso(),
      page_url: window.location.href,
      page_path: window.location.pathname,
      properties: safeProperties,
      attribution: SESSION.attribution,
      session_context: {
        started_at: SESSION.started_at,
        landing_page: SESSION.landing_page,
        referrer: SESSION.referrer
      },
      sequence_number: sequenceNumber,
      schema_version: 1
    };
    EVENT_QUEUE.push(event);
    persistQueue();
    scheduleFlush();
    return event.event_id;
  }

  function payloadFor(events) {
    var firstEvent = events && events[0] ? events[0] : {};
    var eventSession = firstEvent.session_context || {};
    var eventAttribution = firstEvent.attribution || SESSION.attribution || {};
    var firstTouch = eventAttribution.first || eventAttribution.session || eventAttribution || {};
    return {
      schema_version: 1,
      visitor_id: firstEvent.visitor_id || SESSION.visitor_id,
      session_id: firstEvent.session_id || SESSION.session_id,
      visitor: { first_touch: firstTouch },
      session: {
        started_at: eventSession.started_at || SESSION.started_at,
        landing_page: eventSession.landing_page || SESSION.landing_page,
        referrer: eventSession.referrer || SESSION.referrer
      },
      attribution: eventAttribution,
      events: events
    };
  }

  function nextBatch() {
    var first = EVENT_QUEUE[0];
    if (!first) return [];
    return EVENT_QUEUE.filter(function(event) {
      return event.session_id === first.session_id && event.visitor_id === first.visitor_id;
    }).slice(0, MAX_BATCH);
  }

  function beaconBatches() {
    var remaining = EVENT_QUEUE.slice();
    var batches = [];
    while (remaining.length && batches.length < Math.ceil(MAX_QUEUE / MAX_BATCH)) {
      var first = remaining[0];
      var batch = [];
      var rest = [];
      remaining.forEach(function(event) {
        if (
          batch.length < MAX_BATCH &&
          event.session_id === first.session_id &&
          event.visitor_id === first.visitor_id
        ) {
          batch.push(event);
        } else {
          rest.push(event);
        }
      });
      if (!batch.length) break;
      batches.push(batch);
      remaining = rest;
    }
    return batches;
  }

  function removeDelivered(events) {
    var delivered = {};
    events.forEach(function(event) {
      delivered[event.event_id] = true;
    });
    EVENT_QUEUE = EVENT_QUEUE.filter(function(event) {
      return !delivered[event.event_id];
    });
    persistQueue();
  }

  function fetchWithTimeout(body) {
    var options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // Cookies must travel so the API can read and refresh rsp_visitor_id.
      credentials: 'include',
      body: body
    };
    if (window.AbortController) {
      var controller = new AbortController();
      var timeout = setTimeout(function() {
        controller.abort();
      }, FETCH_TIMEOUT_MS);
      options.signal = controller.signal;
      return fetch(ENDPOINT, options).then(function(response) {
        clearTimeout(timeout);
        return response;
      }, function(error) {
        clearTimeout(timeout);
        throw error;
      });
    }
    return fetch(ENDPOINT, options);
  }

  function flush(useBeacon) {
    if (FLUSH_TIMER) {
      clearTimeout(FLUSH_TIMER);
      FLUSH_TIMER = null;
    }
    SESSION = getSessionState();
    if (!EVENT_QUEUE.length) return Promise.resolve(true);
    var events = nextBatch();
    if (!events.length) return Promise.resolve(true);
    var body = JSON.stringify(payloadFor(events));
    if (useBeacon && navigator.sendBeacon) {
      // sendBeacon only confirms browser queueing, not delivery. Keep events
      // persisted until a normal fetch receives an HTTP OK.
      var sentAny = false;
      beaconBatches().forEach(function(batch) {
        var sent = navigator.sendBeacon(ENDPOINT, new Blob([JSON.stringify(payloadFor(batch))], { type: 'text/plain;charset=UTF-8' }));
        sentAny = sentAny || sent;
      });
      if (sentAny) return Promise.resolve(true);
    }
    if (FLUSH_IN_PROGRESS) {
      FLUSH_AGAIN = true;
      return Promise.resolve(false);
    }
    var retryDelay = RETRY_DELAY_MS;
    FLUSH_IN_PROGRESS = true;
    return fetchWithTimeout(body).then(function(response) {
      if (!response.ok) throw new Error('Tracking request failed: ' + response.status);
      removeDelivered(events);
      RETRY_DELAY_MS = 1500;
      return true;
    }).catch(function() {
      persistQueue();
      RETRY_DELAY_MS = Math.min(RETRY_DELAY_MS * 2, 30000);
      return false;
    }).then(function(result) {
      FLUSH_IN_PROGRESS = false;
      var shouldFlushAgain = FLUSH_AGAIN;
      FLUSH_AGAIN = false;
      if (EVENT_QUEUE.length) scheduleFlush((result || shouldFlushAgain) ? 0 : retryDelay);
      return result;
    }, function(error) {
      FLUSH_IN_PROGRESS = false;
      throw error;
    });
  }

  function scheduleFlush(delayMs) {
    if (FLUSH_TIMER) return;
    FLUSH_TIMER = setTimeout(function() {
      FLUSH_TIMER = null;
      flush(false);
    }, typeof delayMs === 'number' ? delayMs : DEFAULT_FLUSH_DELAY_MS);
  }

  function checkoutAttributes() {
    var attr = attribution();
    var first = attr.first || {};
    var session = attr.session || {};
    var raw = session.raw || {};
    return {
      _rsp_session_id: SESSION.session_id,
      _rsp_visitor_id: SESSION.visitor_id,
      _rsp_first_source: first.source || '',
      _rsp_first_campaign_id: first.campaign_id || '',
      _rsp_first_campaign_name: first.campaign_name || '',
      _rsp_first_adset_id: first.adset_id || '',
      _rsp_first_adset_name: first.adset_name || '',
      _rsp_first_ad_id: first.ad_id || '',
      _rsp_first_ad_name: first.ad_name || '',
      _rsp_session_source: session.source || '',
      _rsp_session_campaign_id: session.campaign_id || '',
      _rsp_session_campaign_name: session.campaign_name || '',
      _rsp_session_adset_id: session.adset_id || '',
      _rsp_session_adset_name: session.adset_name || '',
      _rsp_session_ad_id: session.ad_id || '',
      _rsp_session_ad_name: session.ad_name || '',
      _rsp_fbclid: session.fbclid || '',
      _rsp_landing_page: session.landing_page || window.location.href,
      _rsp_referrer: session.referrer || ''
    };
  }

  function appendCheckoutAttributes(target) {
    var attrs = checkoutAttributes();
    if (target instanceof URLSearchParams) {
      Object.keys(attrs).forEach(function(key) {
        if (attrs[key]) target.append('attributes[' + key + ']', attrs[key]);
      });
      return target;
    }
    var url = String(target || '');
    Object.keys(attrs).forEach(function(key) {
      if (attrs[key]) url += '&attributes[' + encodeURIComponent(key) + ']=' + encodeURIComponent(attrs[key]);
    });
    return url;
  }

  window.rspTrack = track;
  window.rspAttribution = attribution;
  window.rspGetCheckoutAttributes = checkoutAttributes;
  window.rspAppendCheckoutAttributes = appendCheckoutAttributes;
  window.rspFlushTracking = function(useBeacon) {
    return flush(useBeacon === true);
  };

  window.addEventListener('pagehide', function() { flush(true); });
  window.addEventListener('online', function() {
    if (EVENT_QUEUE.length) scheduleFlush(0);
  });
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') flush(true);
    if (document.visibilityState === 'visible' && EVENT_QUEUE.length) scheduleFlush(0);
  });

  track('page_view', {
    title: document.title || '',
    referrer: document.referrer || ''
  });
})();
